import { render, staticRenderFns } from "./CustomSurveysCreate.vue?vue&type=template&id=35d57e37&scoped=true&"
import script from "./CustomSurveysCreate.vue?vue&type=script&lang=js&"
export * from "./CustomSurveysCreate.vue?vue&type=script&lang=js&"
import style0 from "./CustomSurveysCreate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomSurveysCreate.vue?vue&type=style&index=1&id=35d57e37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d57e37",
  null
  
)

export default component.exports